'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { Icon } from '@benzinga/core-ui';

interface PortfolioQuoteTableEdgeCTAProps {
  t_code?: string;
  title: string;
  utm: string;
}

export const PortfolioQuoteTableEdgeCTA: React.FC<PortfolioQuoteTableEdgeCTAProps> = ({ title, utm }) => {
  return (
    <EdgeBannerContainer>
      <a
        className="d-block"
        href={`https://www.benzinga.com/premium/ideas/benzinga-edge?utm_source=${utm}&utm_campaign=wallstreetadvantage`}
        target="_blank"
      >
        <div className="flex w-full flex-col lg:flex-row py-4">
          <div className="banner-intro-details basis-1 lg:basis-5/12">
            <div className="flex flex-col justify-center h-full pl-5 items-center lg:items-start">
              <h5 className="uppercase mb-2">Wall Street Level Intel</h5>
              <h2 className="ex-large-font mb-2 text-center lg:text-left">
                Without The <br />
                Wall Street Price Tag
              </h2>
              <p className="uppercase">Learn more about the {title}</p>
            </div>
          </div>
          <div className="benefits-section basis-1 lg:basis-7/12">
            <div className="benefits-clip">
              <div className="flex items-center flex-col py-3">
                <div className="benefits-header px-2">Members Receive</div>
                <ul className="benefits-list p-4">
                  <li>
                    <span>
                      <Icon icon={faCheck} />
                    </span>
                    <span>Full access to the ‘{title}’</span>
                  </li>
                  <li>
                    <span>
                      <Icon icon={faCheck} />
                    </span>
                    <span>Real-time market updates for fast action</span>
                  </li>
                  <li>
                    <span>
                      <Icon icon={faCheck} />
                    </span>
                    <span>Exclusive expert insights</span>
                  </li>
                  <li>
                    <span>
                      <Icon icon={faCheck} />
                    </span>
                    <span>Weekly hidden gem stock picks</span>
                  </li>
                  <li>
                    <span>
                      <Icon icon={faCheck} />
                    </span>
                    <span>Professional-level research tools</span>
                  </li>
                  <li>
                    <span>
                      <Icon icon={faCheck} />
                    </span>
                    <span>In-depth reports to spot emerging trends</span>
                  </li>
                </ul>
                <div className="unlock-access px-3 py-2 rounded">UNLOCK ACCESS NOW</div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </EdgeBannerContainer>
  );
};

const EdgeBannerContainer = styled.div`
  background: white;

  .banner-intro-details {
    font-weight: 800;
    h2 {
      color: #192940;
      font-size: 2.8rem;
      line-height: 1.2;
    }

    h5 {
      color: #3f83f8;
      font-size: 24px;
      letter-spacing: 3px;
    }
    p {
      color: #3f83f8;
    }
  }
  .benefits-section {
    .benefits-clip {
      font-weight: 800;
      clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%);
      @media (max-width: 1023px) {
        clip-path: none;
      }
      background-color: #3f83f8;
      .benefits-header {
        background: #f57f36;
        z-index: 1;
        color: white;
      }
      .benefits-list {
        background: white;
        margin-top: -8px;
        padding-top: 8px;
        color: initial;
        font-weight: 700;
        li {
          display: flex;
          align-items: center;
          gap: 5px;
          span {
            display: inline-flex;
            &:first-of-type {
              color: #3f83f8;
            }
          }
        }
      }
      .unlock-access {
        margin-top: -10px;
        background: #f57f36;
        color: white;
      }
    }
  }
`;
